import {engineContext} from './context.js';

(function(g){'use strict';
const VERSION='0.1.0-alpha';
function need(name, method){const x=g[name];if(!x||typeof x[method]!=='function')throw Error(name+'_'+method+'_REQUIRED');return x;}
function freeze(v){if(v&&typeof v==='object'&&!Object.isFrozen(v)){Object.freeze(v);for(const x of Object.values(v))freeze(x);}return v;}
function nowIso(clock){const d=clock&&typeof clock.now==='function'?clock.now():new Date();return (d instanceof Date?d:new Date(d)).toISOString();}
function create(opts={}){
  const runtimeFactory=need('ZooInvestRuntimeUIV406','create');
  const journalFactory=need('ZooInvestResearchStateEventJournal','create');
  const repositoryFactory=need('ZooInvestResearchStateRepositoryEngine','create');
  const journal=journalFactory.create(opts.journalOptions||{});
  const repository=repositoryFactory.create(opts.repositoryOptions||{});
  const runtime=runtimeFactory.create({...opts.runtimeOptions,pipelineOptions:{...((opts.runtimeOptions||{}).pipelineOptions||{}),journal,persist:null}});
  async function restore(symbol){
    const s=String(symbol||'').trim().toUpperCase(); if(!s)throw Error('SYMBOL_REQUIRED');
    if(typeof repository.load!=='function')return freeze({symbol:s,state:'UNAVAILABLE',record:null});
    try{const record=await repository.load(s);return freeze({symbol:s,state:record?'RESTORED':'EMPTY',record:record||null});}
    catch(e){return freeze({symbol:s,state:'REVIEW',record:null,error:String(e.message||e)});}
  }
  async function run(req={},root=(typeof document!=='undefined'?document:null)){
    const symbol=String(req.symbol||'').trim().toUpperCase(); if(!symbol)throw Error('SYMBOL_REQUIRED');
    const restored=await restore(symbol);
    let result;
    try{result=await runtime.runAndBind({...req,symbol,previousState:restored.record||req.previousState||null},root);}
    catch(e){return freeze({version:VERSION,symbol,status:'REVIEW',restore:restored,runtime:null,persistence:freeze({state:'NOT_ATTEMPTED'}),journal:freeze({state:'NOT_ATTEMPTED'}),issues:freeze([{stage:'RUNTIME',message:String(e.message||e)}])});}
    let persistence={state:'SKIPPED'};
    if(typeof repository.save==='function'){
      try{const saved=await repository.save({symbol,status:result.status,marketContext:result.marketContext||null,ui:result.ui||null,research:result.research||null,execution:result.execution||null,savedAt:nowIso(opts.clock)});persistence={state:'SAVED',record:saved||null};}
      catch(e){persistence={state:'REVIEW',error:String(e.message||e)};}
    }
    let journalState={state:'SKIPPED'};
    if(typeof journal.append==='function'){
      try{await journal.append({type:'SESSION_COMPLETED',symbol,at:nowIso(opts.clock),status:result.status,persistenceState:persistence.state,marketContextState:result.marketContext?.status||null});journalState={state:'APPENDED'};}
      catch(e){journalState={state:'REVIEW',error:String(e.message||e)};}
    }
    const finalStatus=(result.status==='BLOCK'||persistence.state==='REVIEW'||journalState.state==='REVIEW')?'REVIEW':result.status;
    return freeze({version:VERSION,symbol,status:finalStatus,restore:restored,runtime:result,persistence:freeze(persistence),journal:freeze(journalState),guards:freeze({persistenceFailureCannotBecomeReady:true,journalFailureCannotBecomeReady:true,missingStateNotInvented:true,noTradeSignal:true,noCapitalPermission:true,noUniversalScore:true})});
  }
  return Object.freeze({VERSION,restore,run,repository,journal});
}
async function selfTest(){
  const t=[],ok=(n,p)=>t.push({name:n,pass:!!p});
  const oldUI=g.ZooInvestRuntimeUIV406, oldJournal=g.ZooInvestResearchStateEventJournal, oldRepo=g.ZooInvestResearchStateRepositoryEngine;
  try{
    const saved=[],events=[];
    g.ZooInvestResearchStateRepositoryEngine={create:()=>({async load(symbol){return symbol==='AAA'?{symbol:'AAA',status:'REVIEW',revision:2}:null;},async save(state){saved.push(state);return {...state,revision:3};}})};
    g.ZooInvestResearchStateEventJournal={create:()=>({async append(evt){events.push(evt);return evt;}})};
    let capturedReq=null;
    g.ZooInvestRuntimeUIV406={create:()=>({async runAndBind(req){capturedReq=req;return {symbol:req.symbol,status:'READY',marketContext:{status:'READY'},ui:{symbol:req.symbol},research:{status:'READY'},execution:{providerToPackage:true}};}})};
    const clock={now:()=>new Date('2026-08-31T17:00:00Z')};
    const api=create({clock});
    const restored=await api.restore('aaa');
    ok('restore normalizes symbol',restored.symbol==='AAA');
    ok('restore finds record',restored.state==='RESTORED');
    ok('restore preserves revision',restored.record.revision===2);
    const r=await api.run({symbol:'aaa'});
    ok('run normalizes symbol',r.symbol==='AAA');
    ok('previous state forwarded',capturedReq.previousState.revision===2);
    ok('runtime result preserved',r.runtime.status==='READY');
    ok('persistence saved',r.persistence.state==='SAVED');
    ok('one save performed',saved.length===1);
    ok('save uses normalized symbol',saved[0].symbol==='AAA');
    ok('save timestamp controlled',saved[0].savedAt==='2026-08-31T17:00:00.000Z');
    ok('journal appended',r.journal.state==='APPENDED');
    ok('one event appended',events.length===1);
    ok('journal event type',events[0].type==='SESSION_COMPLETED');
    ok('journal event symbol',events[0].symbol==='AAA');
    ok('clean session ready',r.status==='READY');
    ok('no trade signal guard',r.guards.noTradeSignal===true);
    ok('no capital permission guard',r.guards.noCapitalPermission===true);
    ok('no universal score guard',r.guards.noUniversalScore===true);
    const missing=await api.restore('bbb');
    ok('missing restore explicit',missing.state==='EMPTY');
    ok('missing restore record null',missing.record===null);
    g.ZooInvestResearchStateRepositoryEngine={create:()=>({async load(){return null;},async save(){throw Error('SAVE_FAIL');}})};
    const api2=create({clock}); const r2=await api2.run({symbol:'CCC'});
    ok('save failure contained',r2.persistence.state==='REVIEW');
    ok('save failure downgrades session',r2.status==='REVIEW');
    g.ZooInvestResearchStateRepositoryEngine={create:()=>({async load(){throw Error('LOAD_FAIL');},async save(state){return state;}})};
    const api3=create({clock}); const rr=await api3.restore('DDD');
    ok('load failure contained',rr.state==='REVIEW');
    let symbolErr=false;try{await api.run({symbol:''})}catch(e){symbolErr=e.message==='SYMBOL_REQUIRED'}
    ok('symbol required',symbolErr);
    ok('API no score',!('score' in api));
    ok('API no trade signal',!('tradeSignal' in api));
    ok('API no capital permission',!('capitalPermission' in api));
  } finally {g.ZooInvestRuntimeUIV406=oldUI;g.ZooInvestResearchStateEventJournal=oldJournal;g.ZooInvestResearchStateRepositoryEngine=oldRepo;}
  return freeze({passed:t.filter(x=>x.pass).length,total:t.length,tests:t});
}
g.ZooInvestPersistentRuntimeSession=Object.freeze({VERSION,create,selfTest});
})(engineContext);